export enum EventNavigationNames {
	Back = 'navigate back',
	To = 'navigate to',
	LogIn = 'log in',
	LogOut = 'log out',
	StartRecording = 'start recording'
}

export enum EventRecallNames {
	ChangePlanStatus = 'change plan status',
	ChangePlanStatusAccepted = 'change plan status to accepted',
	ChangePlanStatusDraft = 'change plan status to draft',
	ChangePlanStatusPlanned = 'change plan status to planned',
	DownloadPlanPdf = 'download plan pdf',
	DownloadVrsPdf = 'download vrs pdf',
	ResetPlantingPlans = 'reset planting plans',
	DownloadCSIPdf = 'download crop stress index pdf',
}

export enum EventAcreProposalNames {
	AddCustomTreatmentToSeries = 'add custom treatment to series',
	AddPreviouslyOrderedSeriesAndHybrid = 'add previously ordered series and hybrid',
	AddNewTraitToSeries = 'add new product to series',
	AddNewTreatmentToSeries = 'add new treatment to series',
	ConvertAcreProposalToFieldPlan = 'convert acre proposal to field plan',
	CreateNewAcreProposal = 'create new acre proposal',
	RunFieldlessRecommendation = 'ran fieldless recommendation',
	SaveAcreProposal = 'save acre proposal',
	UpdateLocalPositioningText = 'update local positioning',
	UpdateRecommendationAcres = 'update recommendation acres',
	UpdateRecommendationFungicide = 'update recommendation fungicide',
	UpdateRecommendationIrrigation = 'update recommendation irrigation',
	UpdateRecommendationPerf = 'update recommendation performance',
	UpdateRecommendationRmMax = 'update recommendation rm max',
	UpdateRecommendationRmMaxAndMin = 'update recommendation rm max and min (slider)',
	UpdateRecommendationRmMin = 'update recommendation rm min',
	UpdateRecommendationSeedsRequired = 'update recommendation seeds required',
	UpdateRecommendationTargetYield = 'update recommendation target yield',
	UpdateRecommendationTopEndYield = 'update recommendation top end yield',
	UpdateRecommendationTraits = 'update recommendation traits',
	UpdateRecommendationZipCode = 'update recommendation zip code',
	UpdatetHybridValues = 'update hybrid yield acres or quantity',
	ViewExistingAcreProposal = 'view existing acre proposal',
}

export enum EventFieldPlanNames {
	SelectField = 'select a field',
	SelectAllSeries = 'select all series',
	SelectCrop = 'select a crop',
	ChangeSeedsRequiredCount = 'change seeds required count',
	SelectTrait = 'select a trait',
	ChangeRelativeMaturity = 'change relative maturity',
	ChangeIrrigation = 'change irrigation',
	ChangeFungicide = 'change fungicide',
	ChangeConsistency = 'change consistency',
	ChangeTopEndYield = 'change top end yield',
	ClearFilters = 'clear filters',
	CreateFieldPlan = 'create field plan',
	UpdateCropPlan = 'update crop plan',
	RerunCropPlan = 'rerun crop plan',
	CreateCropPlan = 'create crop plan',
	DeleteCropPlan = 'delete crop plan',
	DownloadFieldPlanPdf = 'download plan pdf',
	DeleteFinalCropPlan = 'delete final crop plan',
	ChangeAgronomicRating = 'change agronomic rating',
	ChangeHybridAcresOnField = 'change hybrid acres on field',
	ChangeHybridRateOnField = 'change hybrid rate on field',
	AddHybridToField = 'add hybrid to field',
	RemoveHybridFromField = 'remove hybrid from field',
	ChangeHybridTraitOnField = 'change hybrid trait on field',
	ViewFieldPlan = 'view field plan',
	SelectCropPlan = 'select crop plan',
	NextField = 'next field',
	PreviousField = 'previous field',
	TransferField = 'transfer field',
	EditFields = 'edit fields',
	EditProducts = 'edit products',
	RenameCropPlan = 'rename crop plan',
	ChangeRequestedTrait = 'change requested trait',
	ChangeRequestedTreatmentForTrait = 'change requested treatment for trait',
}

export enum EventMaxScriptNames {
	AddCompetitor = 'add competitors',
	DeleteCompetitor = 'delete competitors',
	SelectCrop = 'select a crop',
	ChangeFieldTargetYield = 'change target yield on field',
	ChangeHybridAcresOnField = 'change hybrid acres on field',
	ChangeHybridRateOnField = 'change hybrid rate on field',
	AddOrRemoveHybridToField = 'add or remove hybrid to field',
	NextField = 'next field',
	PreviousField = 'previous field',
	EditFields = 'edit fields',
	ImportOrder = 'import order',
}

export enum EventFieldActivities
{
	ViewWeather = 'View the weather data for a field'
}

/* Insights is also known as Root Cause */
export enum EventInsightsNames 
{
	OpenInsightsForTerritory = 'open Root Cause for a territory',
	OpenInsightsForSalesRep = 'open Root Cause for a sales rep',
	OpenInsightsSeller = 'open Root Cause for a seller',
	OpenInsightsForGrower = 'open Root Cause for a grower',
}

export type EventNames = (
	EventRecallNames 
	| EventNavigationNames
	| EventFieldPlanNames
	| EventMaxScriptNames
	| EventFieldActivities
	| EventAcreProposalNames
	| EventInsightsNames
);
